<template>
    <div class="fast-search-switcher navbar__search" :class="searchClasses">
        <SearchBar v-if="showNewSearchBar" />
        <template v-else>
            <CompassSwitch v-if="showSwitch" v-model="switcher" size="small" @input="update" />
            <fast-search v-show="switcher" />
            <div v-show="!switcher" class="navbar__search-legacy-container" :class="legacyClasses">
                <div v-click-outside="disableLegacyFocus" @click="enableLegacyFocus">
                    <slot name="legacy"></slot>
                </div>

                <div class="navbar__search-legacy--close" @click="disableLegacyFocus">
                    <CompassIcon icon="close" />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import FastSearch from 'vcomponents/fastsearch/FastSearch.vue';
import LocalStorage from 'Core/commons/LocalStorage';
import Feature from 'Services/Feature';
import SearchBar from 'vcomponents/searchbar/SearchBar.vue';

export default {
    components: {
        FastSearch,
        SearchBar,
    },
    data() {
        return {
            isLegacyFocused: false,
            switcher: true,
            localstorage: new LocalStorage('core', 'new-fast-search'),
        };
    },
    computed: {
        showSwitch() {
            return Feature.isEnabled('legacy-search-engine');
        },
        legacyClasses() {
            return this.isLegacyFocused ? 'navbar__search-legacy-container--focused' : '';
        },
        searchClasses() {
            return !this.switcher ? 'navbar__search--legacy' : '';
        },
        showNewSearchBar() {
            return Feature.isEnabled('search-engine-v3');
        },
    },
    created() {
        if (Feature.isEnabled('legacy-search-engine')) {
            this.switcher = this.localstorage.get() === null ? true : this.localstorage.get();
        }
    },
    methods: {
        update() {
            this.localstorage.set(this.switcher);
        },
        enableLegacyFocus() {
            this.isLegacyFocused = true;

            if (document.body.clientWidth < '1280') {
                const navbarContentWidth = document.querySelector('.navbar-content').offsetWidth;
                const navbarContentActionsWidth = document.querySelector(
                    '.navbar-content__actions',
                ).offsetWidth;
                const navbardSearchLegacyWidth = `calc(100% - ${
                    navbarContentWidth - navbarContentActionsWidth + 8
                }px)`;
                const navBarSearchLegacy = document.querySelector('.navbar__search--legacy');

                if (navBarSearchLegacy) {
                    navBarSearchLegacy.style.width = navbardSearchLegacyWidth;
                }
            }
        },
        disableLegacyFocus() {
            const navBarSearchLegacy = document.querySelector('.navbar__search--legacy');

            if (this.isLegacyFocused && navBarSearchLegacy) {
                this.isLegacyFocused = false;
                navBarSearchLegacy.style.width = 'auto';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.navbar__search {
    max-width: 640px;
    display: flex;
    flex-direction: row;
    flex: 1;
    gap: var(--spacing-1);
    align-items: center;
    order: 1;
    padding: var(--spacing-2) var(--spacing-3) var(--spacing-2) var(--spacing-4);

    &--legacy {
        position: absolute;
        z-index: 1;
        top: 0;
        bottom: 0;
        left: 0;

        padding-right: 0;
        padding-left: var(--spacing-3);
        margin-right: var(--spacing-2);

        background-color: var(--colors-common-background-default);
    }
}

::v-deep {
    // Legacy css managment
    .navbar__search-legacy {
        display: flex;
        align-items: center;

        .fast-select {
            height: 32px;

            font-size: var(--font-size-14);

            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .token-input-list {
            height: 32px;
            font-size: var(--font-size-14);
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            width: 296px;
            @media screen and (width < 1280px) {
                width: 308px;
            }

            #token-input-fast-search-input {
                height: 32px;
                line-height: 32px;
            }
        }

        &--input {
            width: 300px;
            height: 32px;

            font-size: var(--font-size-14);
            line-height: 32px;

            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }

        &-container {
            display: flex;
            gap: var(--spacing-1);
            align-items: center;
            justify-content: space-between;

            #fast-search-cat {
                transition: all 0.2s linear;
                width: 200px;
                @media screen and (width < 1280px) {
                    width: 0;
                    visibility: hidden;
                    opacity: 0;
                    padding: 0;
                }
            }

            .navbar__search-legacy--close {
                cursor: pointer;

                width: 0;
                padding: 0;

                color: var(--colors-common-text-standard-default);

                visibility: hidden;
                display: none;
                opacity: 0;
                border-radius: 4px;

                transition: all 0.2s ease-in-out;

                &:hover {
                    background-color: var(--colors-common-background-selected-hover);
                }
            }

            &--focused {
                @media screen and (width < 1280px) {
                    .token-input-list {
                        width: 293px;
                    }
                    #fast-search-cat {
                        width: 200px;
                        padding: var(--spacing-0) 15px var(--spacing-0) 10px;
                        visibility: visible;
                        opacity: 1;
                    }
                    .navbar__search-legacy--close {
                        width: auto;
                        padding: 6px;
                        visibility: visible;
                        opacity: 1;
                        display: block;
                    }
                }
            }
        }
    }
}
</style>
